import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rounded bg-slate-50 mb-2 px-2 py-4 flex"
};
const _hoisted_2 = {
  class: "grow"
};
const _hoisted_3 = {
  class: "grow flex items-center mb-2"
};
import Status from "@/modules/vue/components/Status.vue";
import { TransferOfferStatusEnum } from "@/modules/transfer-market/enums";
import Player from "@/modules/team/components/Player.vue";
import Team from "@/modules/team/components/Team.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'TransferOfferSlim',
  props: {
    offer: null
  },
  emits: ['close-confirmed', 'abort-confirmed'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const router = useRouter();
    const colorMap = ref({
      [TransferOfferStatusEnum.OPENED]: ColorEnum.Green,
      [TransferOfferStatusEnum.CLOSED]: ColorEnum.Blue,
      [TransferOfferStatusEnum.FAILED]: ColorEnum.Red
    });
    const onClickDetails = () => router.push({
      name: 'transfer-market.team-offers.show',
      params: {
        id: props.offer.id
      }
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(Status, {
        color: __props.offer.playersTeam.user ? _ctx.ColorEnum.Green : _ctx.ColorEnum.Indigo,
        class: "mr-1 flex items-center justify-center p-1"
      }, {
        default: _withCtx(() => [__props.offer.playersTeam.user ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: _ctx.IconEnum.ArrowRight
        }, null, 8, ["icon"])) : (_openBlock(), _createBlock(_component_Icon, {
          key: 1,
          icon: _ctx.IconEnum.ArrowLeft
        }, null, 8, ["icon"]))]),
        _: 1
      }, 8, ["color"]), _createVNode(Status, {
        color: colorMap.value[__props.offer.status],
        class: "inline-block mr-2"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.offer.status), 1)]),
        _: 1
      }, 8, ["color"]), _createElementVNode("div", null, _toDisplayString(_ctx.$money(__props.offer.price)), 1)]), _createVNode(Player, {
        player: __props.offer.player,
        class: "mb-2"
      }, null, 8, ["player"]), _createVNode(Team, {
        team: __props.offer.team
      }, null, 8, ["team"])]), _createElementVNode("div", null, [_createVNode(_component_NButton, {
        secondary: "",
        type: "primary",
        onClick: onClickDetails
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('details')), 1)]),
        _: 1
      })])]);
    };
  }
});